var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EEEEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.627 9.23013C23.9339 9.53697 23.9339 10.0345 23.627 10.3413L16.1627 17.8056C15.8559 18.1124 15.3584 18.1124 15.0516 17.8056L11.6786 14.4326L6.3413 19.7699C6.03446 20.0767 5.53697 20.0767 5.23013 19.7699C4.92329 19.4631 4.92329 18.9655 5.23013 18.6587L11.123 12.7658C11.4298 12.459 11.9273 12.459 12.2342 12.7658L15.6072 16.1389L22.5159 9.23013C22.8227 8.92329 23.3202 8.92329 23.627 9.23013Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5713 9.78572C17.5713 9.35178 17.9231 9 18.357 9H23.0713C23.5052 9 23.857 9.35178 23.857 9.78572V14.5C23.857 14.934 23.5052 15.2857 23.0713 15.2857C22.6373 15.2857 22.2856 14.934 22.2856 14.5V10.5714H18.357C17.9231 10.5714 17.5713 10.2197 17.5713 9.78572Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocks);
export default __webpack_public_path__ + "static/media/stocks.f6368bbc635f3b6bc97ab5c2a6022ff2.svg";
export { ForwardRef as ReactComponent };